<template>
  <div v-if="dataApi" class="body-bg-img-comp"
        v-bind:style="{
        position: `${this.modulePropsData?.backgroundPostion || ''}`,
        top: `${this.modulePropsData?.backgroundTop || ''}`,
        height: `${this.modulePropsData?.backgroundHeight || ''}`,
        width: `${this.modulePropsData?.backgroundWidth || ''}`,
      }"
  >
    <img
      alt="image"
      :src="dataApi" 
      loading="lazy"
    />
    <div 
      class="transparent-layer"
      v-bind:style="{
        position: `${this.modulePropsData?.backgroundPostion || ''}`,
        height: `${this.modulePropsData?.transparentElemHeight || ''}`,
        width: `${this.modulePropsData?.backgroundWidth || ''}`,
      }"
    >
    </div>
  </div>
</template>

<script>
export default {
  name: "BodyBackgroundComponent",
  props: ["dataApi", "moduleProps"],
  data() {
    return {
      modulePropsData: {},
      isVisible: false,
      class: {
        backgroundImgClassname: 'body-bg-img',
        backgroundTransparentClassname: 'transparent'
      },
    }
  },
  mounted() {
    this.modulePropsData = 
      typeof this.moduleProps != null &&
      typeof this.moduleProps != "null" &&
      typeof this.moduleProps != "undefined"
        ? JSON.parse(this.moduleProps)
        : {};
    const backgroundClassString = this.modulePropsData?.backgroundClasses || '';
    const backgroundClasses = backgroundClassString.split(',');
    if(backgroundClasses.length > 0 && this.dataApi) {
      let ele = document.getElementsByClassName("pg-wrapper");
      for(let index in backgroundClasses) {
        ele[0].classList.add(`${backgroundClasses[index].replace(/\s/g, '')}`);
      }
    }
  },
}
</script>

<style></style>